<template>
  <div></div>
</template>

<script>
import { routesName } from "../router/index";
import { firestoreDatabase } from "../services/firestore";
import { firestoreData } from "../utils/enums";
import { mapState } from "vuex";
export default {
  data() {
    return {
      goToFeedback: true,
    };
  },
  computed: {
    ...mapState(["playerEmail", "alreadyPlay", "startDateWeek", "endDateWeek"]),
  },
  methods: {
    filterPlayerSession(playerEmail, { startDate, endDate }) {
      return (
        playerEmail == this.playerEmail &&
        startDate == this.startDateWeek &&
        endDate == this.endDateWeek
      );
    },
  },
  mounted() {
    if (this.alreadyPlay) {
      firestoreDatabase
        .collection(firestoreData.COLLECTION_NAME)
          .orderBy('startDate', 'desc')
        .get()
        .then(({ docs }) => {
          const gameFeedback = docs.find((register) => {
            const data = register.data();
            return this.filterPlayerSession(
              data.playerEmail,
              data.sessionDataRange
            );
          });
          if (gameFeedback) {
            this.$store.dispatch(
              "loadQuestionsFromFirestore",
              gameFeedback.data()
            );
            this.$router.push(routesName.feedback);
          }
        });
    } else {
      this.$router.push(routesName.gameExplanation);
    }
  },
};
</script>

<style></style>
